import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, AuthenticationService, ShadowService } from 'src/app/shared/_services';
import { TransactionsStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-create-dispute',
  templateUrl: './create-dispute.page.html',
  styleUrls: ['./create-dispute.page.scss'],
})
export class CreateDisputePage implements OnInit, DoCheck {
  createDisputeDetails = this.transactionsStore.getCreateDisputeDetails();
  disabled = true;
  disableIssue = false;
  disableOther = false;
  hideSpinner = true;
  timeout: any;
  other: any;
  issue: any;
  issues = [
    { id: '1', name: 'Transaction took too long to process' },
    { id: '2', name: 'Funds not received' },
    { id: '3', name: 'Network Error' }
  ];

  constructor(
    private router: Router,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private shadowService: ShadowService,
    private transactionsStore: TransactionsStore
  ) { }
  clearSelection() {
    this.issue = ' ';
  }
  submitDisputeForm() {
    this.hideSpinner =  false;
    this.auth.createDispute(this.issue, this.other, this.createDisputeDetails.reference)
    .subscribe(
      response => {
        this.hideSpinner = true;
        console.log(response);
        this.alertService.standardAlert(
          // tslint:disable-next-line:max-line-length
          'Your issue has been received and would now be handled by our Support Team. An email would be sent to you after resolution. Going back to your Dashboard'
        );
        this.timeout = setTimeout(() => {
          return this.router.navigateByUrl('/dashboard');
        }, 7000);
      },
      error => {
        this.hideSpinner = true;
        console.log(error);
        // this.alertService.standardAlert('Couldn\'t Create Dispute. Please try again');
      }
    );
  }

  goBack() {
    this.router.navigateByUrl('/transactions');
    clearTimeout(this.timeout);
  }

  ionViewWillEnter() {
    document.title = 'Create Dispute | Bank3D';
    this.shadowService.button();
  }

  ngOnInit() {
    this.issue = '';
    this.other = '';
  }

  ngDoCheck(): void {
    if (this.issue.length > 1) {
      this.disabled = false;
      this.disableOther = true;
      this.other = ' ';
    } else if (this.other.length > 1) {
      this.disabled = false;
      this.disableIssue = true;
      this.issue = ' ';
    } else {
      this.disabled = true;
      this.disableIssue = false;
      this.disableOther = false;
    }
  }

}
